import React from 'react';
import { useTranslate } from '@src/core/hooks';

import { getCartTariffVerificationError } from '@src/domains/tariffs/core/tariffVerificationFields/getCartTariffVerificationError';
import { getFieldError } from '@src/domains/tariffs/core/tariffVerificationFields/getFieldError';
import { getVerificationValue } from '@src/domains/tariffs/core/tariffVerificationFields/getVerificationValue';

import Field from './Field';
import { FieldsContainer, LoadingText, PersonContainer } from './styles';
import type { VerificationFieldsProps } from './types';
import { useVerificationFields } from './useVerificationFields';

const VerificationFields = (props: VerificationFieldsProps) => {
  const { tariffTypeId, quantity, tariffTypePosition } = props;
  const { i18n } = useTranslate();

  const {
    loading,
    tariffHasValidationsToRender,
    arrayOfQuantity,
    verificationValuesWithoutUnrendered,
    tariffWithVerificationValues,
    cartErrors,
    handleValueChange,
  } = useVerificationFields({ tariffTypeId, quantity });

  if (!tariffHasValidationsToRender) return null;

  if (loading) {
    return (
      <FieldsContainer>
        <LoadingText>{i18n('base_loading')}</LoadingText>
      </FieldsContainer>
    );
  }

  return (
    <FieldsContainer>
      {arrayOfQuantity.map((_, tariffUnitIndex) => (
        <PersonContainer key={tariffUnitIndex}>
          {verificationValuesWithoutUnrendered.map((tariffTypeVerification, verificationIndex) => (
            <Field
              key={`${tariffTypeVerification.id}-${tariffUnitIndex}`}
              tariffTypeVerification={tariffTypeVerification}
              tariffUnitIndex={tariffUnitIndex}
              initialValue={getVerificationValue(
                tariffWithVerificationValues,
                tariffTypeId,
                tariffTypeVerification.tariffVerificationId,
                tariffUnitIndex,
                verificationIndex,
              )}
              getFieldError={(verificationId) =>
                getFieldError(tariffWithVerificationValues, verificationId, tariffUnitIndex, verificationIndex)
              }
              getCartTariffVerificationError={() =>
                getCartTariffVerificationError(
                  cartErrors ?? {},
                  tariffUnitIndex,
                  verificationIndex,
                  verificationValuesWithoutUnrendered.length,
                  tariffTypePosition ?? 0,
                )
              }
              handleValueChange={(verificationId, value) =>
                handleValueChange(verificationId, value, tariffUnitIndex, verificationIndex)
              }
            />
          ))}
        </PersonContainer>
      ))}
    </FieldsContainer>
  );
};

export default VerificationFields;
